import React from 'react'

import Button from 'material-ui/Button'
import SaveIcon from 'material-ui-icons/Save'
import { CircularProgress } from 'material-ui/Progress'

const Export = ({ onExport, isExportRequestOngoing }) =>
  <Button
    id='export'
    variant='fab'
    color='primary'
    onClick={onExport}
    disabled={isExportRequestOngoing}
  >
    {isExportRequestOngoing ? <CircularProgress /> : <SaveIcon />}
  </Button>

export default Export



// WEBPACK FOOTER //
// ./src/jobs/Export.js